import AppStore from '../stores/index';
import { loading } from '../stores/globalLoader/actions';

export function showLoadingBar(isLoading: boolean) {
  AppStore.dispatch(loading(isLoading));
}
